<template>
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00141 10.8944C9.41525 10.8944 10.5614 9.74826 10.5614 8.33441C10.5614 6.92056 9.41525 5.77441 8.00141 5.77441C6.58756 5.77441 5.44141 6.92056 5.44141 8.33441C5.44141 9.74826 6.58756 10.8944 8.00141 10.8944Z"
      fill="#232323"
    />
    <path
      d="M5.6 0.333008L4.136 1.93301H1.6C0.72 1.93301 0 2.65301 0 3.53301V13.133C0 14.013 0.72 14.733 1.6 14.733H14.4C15.28 14.733 16 14.013 16 13.133V3.53301C16 2.65301 15.28 1.93301 14.4 1.93301H11.864L10.4 0.333008H5.6ZM8 12.333C5.792 12.333 4 10.541 4 8.33301C4 6.12501 5.792 4.33301 8 4.33301C10.208 4.33301 12 6.12501 12 8.33301C12 10.541 10.208 12.333 8 12.333Z"
      fill="#232323"
    />
  </svg>
</template>
